var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGdpr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#F0B429"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6641 25.333C13.6641 22.976 13.6641 21.7975 14.3963 21.0653C15.1285 20.333 16.307 20.333 18.6641 20.333H25.3307C27.6877 20.333 28.8662 20.333 29.5985 21.0653C30.3307 21.7975 30.3307 22.976 30.3307 25.333C30.3307 27.69 30.3307 28.8685 29.5985 29.6008C28.8662 30.333 27.6877 30.333 25.3307 30.333H18.6641C16.307 30.333 15.1285 30.333 14.3963 29.6008C13.6641 28.8685 13.6641 27.69 13.6641 25.333Z",
    stroke: "#010E20",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.3332V18.6665C17 15.9051 19.2386 13.6665 22 13.6665C24.3298 13.6665 26.2874 15.26 26.8425 17.4165",
    stroke: "#010E20",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23.6665V26.9998",
    stroke: "#010E20",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdpr);
export default __webpack_public_path__ + "static/media/gdpr.427d985cdb1e6c80f2636f2d4bc58904.svg";
export { ForwardRef as ReactComponent };